var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "mall-header" },
                [
                  _c("span", { staticClass: "mall-title" }, [
                    _vm._v(_vm._s(_vm.modeTitle)),
                  ]),
                  _vm.mode !== "qgd"
                    ? _c(
                        "a-select",
                        {
                          staticStyle: { width: "260px" },
                          attrs: {
                            showSearch: "",
                            optionFilterProp: "children",
                            placeholder:
                              _vm.mode === "cgdd"
                                ? "请选择供应商（仅显示其归属商品）"
                                : "请选择上级供应商（显示其可售商品）",
                          },
                          on: { change: _vm.onOwnerChange },
                          model: {
                            value: _vm.ownerId,
                            callback: function ($$v) {
                              _vm.ownerId = $$v
                            },
                            expression: "ownerId",
                          },
                        },
                        _vm._l(_vm.ownerOptions, function (o) {
                          return _c(
                            "a-select-option",
                            { key: o.id, attrs: { value: o.id } },
                            [_vm._v(_vm._s(o.name))]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _c("a-input-search", {
                    staticStyle: { width: "240px" },
                    attrs: { placeholder: "商品名称搜索" },
                    on: { search: _vm.onSearch },
                    model: {
                      value: _vm.searchKeyword,
                      callback: function ($$v) {
                        _vm.searchKeyword = $$v
                      },
                      expression: "searchKeyword",
                    },
                  }),
                  _c(
                    "a-radio-group",
                    {
                      on: { change: _vm.onTabChange },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    _vm._l(_vm.tabs, function (t) {
                      return _c(
                        "a-radio-button",
                        { key: t.key, attrs: { value: t.key } },
                        [_vm._v(_vm._s(t.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.mode !== "qgd" && !_vm.ownerId
                ? _c(
                    "div",
                    { staticClass: "mall-empty" },
                    [
                      _c("a-icon", {
                        staticStyle: { "font-size": "40px", color: "#ccc" },
                        attrs: { type: "shop" },
                      }),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.mode === "cgdd"
                              ? "请先选择供应商，进入后仅显示该供应商归属的商品"
                              : "请先选择绑定的上级供应商，进入后显示上级可售商品"
                          )
                        ),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "a-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c("a-col", { attrs: { span: 4 } }, [
                        _c(
                          "div",
                          { staticClass: "mall-category" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "mall-cat-item",
                                class: { active: _vm.activeCategory === "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onCategoryChange("")
                                  },
                                },
                              },
                              [_vm._v("全部")]
                            ),
                            _vm._l(_vm.categories, function (c) {
                              return _c(
                                "div",
                                {
                                  key: c.id,
                                  staticClass: "mall-cat-item",
                                  class: {
                                    active:
                                      String(_vm.activeCategory) ===
                                      String(c.id),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onCategoryChange(c.id)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(c.name))]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                      _c(
                        "a-col",
                        { attrs: { span: 14 } },
                        [
                          _c("a-table", {
                            attrs: {
                              size: "middle",
                              bordered: "",
                              rowKey: "id",
                              columns: _vm.goodsColumns,
                              dataSource: _vm.goods,
                              pagination: false,
                              loading: _vm.goodsLoading,
                              scroll: { y: 420 },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "img",
                                fn: function (text, record) {
                                  return [
                                    record.imgUrl
                                      ? _c("img", {
                                          class: [
                                            "mall-goods-img",
                                            {
                                              "mall-goods-img-click":
                                                record.imgUrls &&
                                                record.imgUrls.length,
                                            },
                                          ],
                                          attrs: {
                                            src: record.imgUrl,
                                            alt: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openPreview(record)
                                            },
                                          },
                                        })
                                      : _c("span", [_vm._v("-")]),
                                  ]
                                },
                              },
                              {
                                key: "price",
                                fn: function (text, record) {
                                  return [
                                    !_vm.priceHidden
                                      ? _c("span", [
                                          _vm._v(_vm._s(record.priceText)),
                                        ])
                                      : _c("span", [_vm._v("-")]),
                                  ]
                                },
                              },
                              {
                                key: "action",
                                fn: function (text, record) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "mall-stepper" },
                                      [
                                        _c("a-icon", {
                                          class: [
                                            "mall-step-btn",
                                            { off: !_vm.cartNumberOf(record) },
                                          ],
                                          attrs: { type: "minus" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onMinus(record)
                                            },
                                          },
                                        }),
                                        _c("input", {
                                          staticClass: "mall-step-input",
                                          attrs: {
                                            inputmode: "decimal",
                                            type: "text",
                                          },
                                          domProps: {
                                            value: record.inputNumber,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.onNumInput(
                                                record,
                                                $event
                                              )
                                            },
                                            blur: function ($event) {
                                              return _vm.onNumBlur(record)
                                            },
                                          },
                                        }),
                                        _c("a-icon", {
                                          staticClass: "mall-step-btn",
                                          attrs: { type: "plus" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onPlus(record)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("a-pagination", {
                            staticStyle: {
                              "margin-top": "12px",
                              "text-align": "right",
                            },
                            attrs: {
                              current: _vm.pagination.current,
                              pageSize: _vm.pagination.pageSize,
                              total: _vm.pagination.total,
                              showTotal: (t) => "共 " + t + " 条",
                            },
                            on: { change: _vm.onPageChange },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "a-card",
                            {
                              attrs: {
                                size: "small",
                                bodyStyle: { padding: "8px" },
                              },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v("\n              已选清单"),
                                _c("span", { staticClass: "mall-cart-count" }, [
                                  _vm._v(
                                    "（已选 " + _vm._s(_vm.cartCount) + " 种）"
                                  ),
                                ]),
                              ]),
                              _vm.cartItems.length === 0
                                ? _c(
                                    "div",
                                    { staticClass: "mall-cart-empty" },
                                    [_vm._v("暂未选择商品")]
                                  )
                                : _vm._e(),
                              _vm._l(_vm.cartItems, function (item) {
                                return _c(
                                  "div",
                                  {
                                    key: item.materialId,
                                    staticClass: "mall-cart-item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mall-cart-name",
                                        attrs: {
                                          title:
                                            item.name +
                                            (item.standard
                                              ? "（" + item.standard + "）"
                                              : ""),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(item.name)
                                        ),
                                        item.standard
                                          ? _c("span", [
                                              _vm._v(
                                                "（" +
                                                  _vm._s(item.standard) +
                                                  "）"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "mall-cart-line" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "mall-stepper" },
                                          [
                                            _c("a-icon", {
                                              class: [
                                                "mall-step-btn",
                                                { off: !item.number },
                                              ],
                                              attrs: { type: "minus" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onCartMinus(item)
                                                },
                                              },
                                            }),
                                            _c("input", {
                                              staticClass: "mall-step-input",
                                              attrs: {
                                                inputmode: "decimal",
                                                type: "text",
                                              },
                                              domProps: {
                                                value: item.numberText,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.onCartInput(
                                                    item,
                                                    $event
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.onCartBlur(item)
                                                },
                                              },
                                            }),
                                            _c("a-icon", {
                                              staticClass: "mall-step-btn",
                                              attrs: { type: "plus" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onCartPlus(item)
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "mall-cart-unit" },
                                          [_vm._v(_vm._s(item.unit))]
                                        ),
                                        !_vm.priceHidden
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "mall-cart-amount",
                                              },
                                              [
                                                _vm._v(
                                                  "¥" + _vm._s(item.amountText)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("a-icon", {
                                          staticClass: "mall-cart-del",
                                          attrs: { type: "delete" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeFromCart(item)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                              _vm.cartItems.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "mall-cart-footer" },
                                    [
                                      !_vm.priceHidden
                                        ? _c("span", [
                                            _vm._v("合计："),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "mall-cart-total",
                                              },
                                              [
                                                _vm._v(
                                                  "¥" +
                                                    _vm._s(_vm.cartTotalText)
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                      _c(
                                        "a-button",
                                        {
                                          staticStyle: { float: "right" },
                                          attrs: {
                                            type: "primary",
                                            icon: "check",
                                          },
                                          on: { click: _vm.openConfirm },
                                        },
                                        [_vm._v("提交请购")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "确认提交",
                    visible: _vm.confirmVisible,
                    confirmLoading: _vm.submitting,
                    maskClosable: false,
                  },
                  on: {
                    ok: _vm.handleSubmit,
                    cancel: function ($event) {
                      _vm.confirmVisible = false
                    },
                  },
                },
                [
                  _c("a-table", {
                    attrs: {
                      size: "small",
                      bordered: "",
                      rowKey: "materialId",
                      columns: _vm.confirmColumns,
                      dataSource: _vm.confirmItems,
                      pagination: false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "number",
                        fn: function (text, item) {
                          return [
                            _c(
                              "div",
                              { staticClass: "mall-stepper" },
                              [
                                _c("a-icon", {
                                  class: [
                                    "mall-step-btn",
                                    { off: !item.number },
                                  ],
                                  attrs: { type: "minus" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onConfirmMinus(item)
                                    },
                                  },
                                }),
                                _c("input", {
                                  staticClass: "mall-step-input",
                                  attrs: { inputmode: "decimal", type: "text" },
                                  domProps: { value: item.numberText },
                                  on: {
                                    input: function ($event) {
                                      return _vm.onConfirmInput(item, $event)
                                    },
                                    blur: function ($event) {
                                      return _vm.onConfirmBlur(item)
                                    },
                                  },
                                }),
                                _c("a-icon", {
                                  staticClass: "mall-step-btn",
                                  attrs: { type: "plus" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onConfirmPlus(item)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  !_vm.priceHidden
                    ? _c("div", { staticClass: "mall-confirm-total" }, [
                        _vm._v("合计：¥" + _vm._s(_vm.confirmTotalText)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "a-modal",
                {
                  attrs: {
                    visible: _vm.previewVisible,
                    footer: null,
                    width: 860,
                    bodyStyle: { padding: "0", background: "#000" },
                  },
                  on: { cancel: _vm.closePreview },
                },
                [
                  _c("div", { staticClass: "mall-preview" }, [
                    _c("div", { staticClass: "mall-preview-count" }, [
                      _vm._v(
                        _vm._s(_vm.previewIndex + 1) +
                          " / " +
                          _vm._s(_vm.previewList.length)
                      ),
                    ]),
                    _vm.previewList.length > 1
                      ? _c(
                          "span",
                          {
                            staticClass: "mall-preview-arrow left",
                            on: { click: _vm.prevPreview },
                          },
                          [_vm._v("‹")]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "mall-preview-body",
                        on: { click: _vm.toggleZoom },
                      },
                      [
                        _c("img", {
                          class: [
                            "mall-preview-img",
                            { zoomed: _vm.previewZoom },
                          ],
                          attrs: {
                            src: _vm.previewList[_vm.previewIndex],
                            alt: "",
                          },
                        }),
                      ]
                    ),
                    _vm.previewList.length > 1
                      ? _c(
                          "span",
                          {
                            staticClass: "mall-preview-arrow right",
                            on: { click: _vm.nextPreview },
                          },
                          [_vm._v("›")]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }